import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useReveal } from "./Home";
import Seo from "../components/Seo";

const Team = () => {
  const navigate = useNavigate();
  const ref = useReveal();
  const { t, lp } = useLang();

  return (
    <div ref={ref}>
      <Seo title={t.seo.team.title} description={t.seo.team.description} />
      <section className="relative overflow-hidden bg-[#0f1a10] pb-20 pt-40">
        <div className="absolute inset-0 opacity-20">
          <img src={t.hero.slides[2]} alt="" className="h-full w-full object-cover grayscale" />
        </div>
        <div className="relative mx-auto max-w-[1200px] px-6">
          <span className="text-sm font-semibold uppercase tracking-widest text-[#F26522]">Team</span>
          <h1 className="mt-3 max-w-3xl text-4xl font-extrabold leading-tight text-white lg:text-5xl">{t.team.title}</h1>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-neutral-300">{t.team.intro}</p>
        </div>
      </section>

      <section className="mx-auto max-w-[1200px] px-6 py-20 lg:py-24">
        <div className="space-y-16">
          {t.team.members.map((m, i) => {
            const flip = i % 2 === 1;
            return (
              <div key={m.slug} className={`reveal grid items-center gap-10 lg:grid-cols-5 ${flip ? "lg:[&>*:first-child]:order-2" : ""}`}>
                <div className="lg:col-span-2">
                  <button
                    onClick={() => navigate(lp(`/team/${m.slug}`))}
                    className="group block w-full overflow-hidden rounded-2xl shadow-lg"
                  >
                    <img src={m.image} alt={m.name} className="aspect-[4/5] w-full object-cover grayscale transition-all duration-500 group-hover:scale-105 group-hover:grayscale-0" />
                  </button>
                </div>
                <div className="lg:col-span-3">
                  <h2 className="text-2xl font-bold text-neutral-900">{m.name}</h2>
                  <p className="mt-1 text-sm font-semibold uppercase tracking-wide text-[#F26522]">{t.team.role}</p>
                  <blockquote className="mt-6 border-l-4 border-[#F26522] pl-6 text-lg italic leading-relaxed text-neutral-700">“{m.quote}”</blockquote>
                  <button
                    onClick={() => navigate(lp(`/team/${m.slug}`))}
                    className="group mt-6 inline-flex items-center gap-2 rounded-md border border-neutral-300 px-6 py-2.5 text-sm font-semibold text-neutral-800 transition-all duration-300 hover:border-[#F26522] hover:text-[#F26522]"
                  >
                    {t.team.profileCta}
                    <ChevronRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="bg-neutral-50 py-20">
        <div className="reveal mx-auto max-w-2xl px-6 text-center">
          <h2 className="text-3xl font-bold text-neutral-900">{t.team.joinTitle}</h2>
          <p className="mt-4 text-[15px] leading-relaxed text-neutral-600">{t.team.joinText}</p>
          <button onClick={() => navigate(lp("/contact"))}
            className="group mt-8 inline-flex items-center gap-2 rounded-md bg-[#F26522] px-8 py-4 text-base font-semibold text-white transition-all duration-300 hover:bg-[#d9561a] hover:shadow-xl">
            {t.team.joinCta}
            <ChevronRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </div>
      </section>
    </div>
  );
};

export default Team;
